"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const useSimulationStore_1 = require("../../../../stores/useSimulationStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'color-interior-list-item',
    props: {
        interiorColor: null
    },
    setup(__props) {
        const props = __props;
        const store = (0, useSimulationStore_1.useSimulationStore)();
        const handleColor = () => {
            store.interiorColor = props.interiorColor;
        };
        return { __sfc: true, store, props, handleColor };
    }
});
